<template>
	<form class="form form--has-fixed-group" novalidate>
		<div ref="success" v-show="success" class="alert alert--success">
			{{ currentUser ? 'Your password has been updated' : 'User password has been updated' }}
		</div>

		<div class="grid">
			<div class="col-12 col-md-6">
				<fieldset class="form__group">
					<legend>Change Password</legend>

					<div class="form__group">
						<input id="current-password" type="password" name="currentPassword"
						       class="form__control" v-model="formData.currentPassword"
						       placeholder="Enter existing password here..."
						       v-validate required />
						<label for="current-password" class="form__label">Existing Password</label>
						<div class="form__validation">{{ errors.first('currentPassword') }}</div>
					</div>

					<div class="form__group">
						<input id="new-password" type="password" name="newPassword"
						       class="form__control" v-model="formData.newPassword"
						       placeholder="Enter new password here..."
						       v-validate required />
						<label for="new-password" class="form__label">New Password</label>
						<div class="form__validation">{{ errors.first('newPassword') }}</div>
					</div>

					<div class="form__group">
						<input id="confirm-password" type="password" name="confirmPassword"
						       class="form__control" v-model="formData.newPassword_confirmation"
						       placeholder="Re-enter new password here..."
						       v-validate required />
						<label for="confirm-password" class="form__label">Confirm New Password</label>
						<div class="form__validation">{{ errors.first('confirmPassword') }}</div>
					</div>
				</fieldset>
			</div>
		</div>

		<div class="form__group form__group--submit-fixed">
			<button class="btn btn--primary" @click.prevent="submit"
			        v-wait:disabled="waitName">Save Changes</button>
		</div>
	</form>
</template>

<script>
	import API from './../../../api';
	import UserFormTab from './UserFormTab';

	export default {
		name: 'UserFormPassword',
		mixins: [UserFormTab],
		data() {
			return {
				waitName: 'updatePassword',
				formData: {
					currentPassword: null,
					newPassword: null,
					newPassword_confirmation: null, //Laravel :(
				},
			};
		},
		methods: {
			save() {
				return API.updateUserPassword(this.id, this.formData);
			},
		}
	}
</script>
